import React, { useEffect, useState } from 'react';

import {
  Grid,
  TextField,
  InputAdornment,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import TablePeo from '../../../Components/TablePeo';
import SearchIcon from '@mui/icons-material/Search';
import { useApiGet } from '../../../utils/httpClient';
import { getLCMembers } from '../../../endpoints/chapters';
import DateFilter from '../../../Components/DateFilter';
import dayjs from 'dayjs';

const headCells = [
  {
    id: 'first_name',
    firstCell: true,
    label: 'First Name',
    width: '30%',
  },
  {
    id: 'last_name',
    firstCell: true,
    label: 'Last Name',
    width: '30%',
  },

  {
    id: 'chapter_start_date',
    label: 'Joined Chapter',
    width: '20%',
  },
  {
    id: 'member_start_date',
    label: 'Initiation',
    width: '20%',
  },
];

const LCMembers = ({ id, lcAccess, lcAction }) => {
  const [order, setOrder] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [userType, setUserType] = useState('member-active');
  const [dateSince, setDateSince] = useState(dayjs().subtract(10, 'year'));

  const { data: returnData, isFetching } = useApiGet(
    ['lc-members', id, userType, dateSince],
    getLCMembers,
    {
      enabled: true,
      retry: 1,
    },
    { id, userType, dateSince }
  );

  useEffect(() => {
    if (returnData && !isFetching) {
      setData(returnData);
      setOriginalData(returnData);
    }
  }, [returnData, isFetching]);

  useEffect(() => {
    // we can do client side filtering here
    const filteredData = originalData?.filter((item) => {
      return (
        item.first_name.toLowerCase().includes(search.toLowerCase()) ||
        item.last_name.toLowerCase().includes(search.toLowerCase())
      );
    });
    setData(filteredData);
  }, [search, originalData]);

  const handleClick = (event, id) => {
    window.location.href = `/user/${id}`;
  };

  const handleUserTypeChange = (value) => {
    setUserType(value);
  };

  if (isFetching) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">Loading...</Typography>
      </Grid>
    );
  }
  if (!data) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">No data available</Typography>
      </Grid>
    );
  }

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid container>
        {lcAction && (
          <Grid item xs={12} padding textAlign={'right'}>
            <Button
              variant="contained"
              onClick={() => {
                window.location.href = `/user?type=member-all`;
              }}
              color="green"
              sx={{ fontWeight: 'bold' }}
            >
              Add / Transfer
            </Button>
          </Grid>
        )}
        <Grid item xs={12} sm={6} paddingRight={2} paddingBottom={3}>
          <TextField
            label="Search"
            id="search-field"
            size="small"
            value={search}
            fullWidth={true}
            onChange={(event) => setSearch(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={3} paddingRight={2} paddingBottom={3}>
          <FormControl fullWidth size={'small'}>
            <InputLabel id="user-type-label">User Type</InputLabel>
            <Select
              labelId="user-type-label"
              id="user-type-select"
              value={userType}
              label="User Type"
              onChange={(event) => handleUserTypeChange(event.target.value)}
            >
              <MenuItem value={'member-all'}>All Members</MenuItem>
              <MenuItem value={'member-active'}>Active Members</MenuItem>
              <MenuItem value={'member-inactive'}>Inactive Members</MenuItem>
              <MenuItem value={'member-deceased'}>Deceased Members</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {['member-all', 'member-inactive', 'member-deceased'].includes(
          userType
        ) && (
          <Grid item xs={12} md={3} paddingRight={2} paddingBottom={3}>
            <DateFilter
              label={
                userType === 'member-deceased'
                  ? 'Deceased After'
                  : 'Inactive After'
              }
              filterValue={dateSince}
              updateFilters={setDateSince}
            />
          </Grid>
        )}
      </Grid>
      <TablePeo
        data={data}
        isFetching={isFetching}
        headCells={headCells}
        handleRowClick={handleClick}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        pagination={false}
      />
    </Grid>
  );
};

export default LCMembers;
